import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

/** Saisie du Personnel retenue pour validation */
export interface SaisieEnAttente {
  id: number;
  statut: 'EN_ATTENTE' | 'VALIDEE' | 'REJETEE';
  libelle: string;
  detail?: string;
  element?: string;
  module?: string;
  auteurNom?: string;
  dateSaisie?: string;
  creeLe?: string;
  corpsJson?: string;
  motif?: string;
  traiteePar?: string;
}

/** Validation des saisies du Personnel (administrateur, gestionnaire) */
@Injectable({ providedIn: 'root' })
export class SaisiesEnAttenteService {

  private readonly base = `${environment.BASE_URL}/api/saisies-en-attente`;

  constructor(private http: HttpClient) {}

  liste(statut?: string): Observable<SaisieEnAttente[]> {
    return this.http.get<SaisieEnAttente[]>(this.base, { params: statut ? { statut } : {} });
  }

  compte(): Observable<{ enAttente: number; validationActive: boolean }> {
    return this.http.get<{ enAttente: number; validationActive: boolean }>(`${this.base}/compte`);
  }

  /** corps : la saisie corrigée, sinon celle de l'agent */
  valider(id: number, corps?: any): Observable<SaisieEnAttente> {
    return this.http.post<SaisieEnAttente>(`${this.base}/${id}/valider`, corps ? { corps } : {});
  }

  rejeter(id: number, motif?: string): Observable<SaisieEnAttente> {
    return this.http.post<SaisieEnAttente>(`${this.base}/${id}/rejeter`, { motif: motif || null });
  }
}
